import { AUTH } from '../constants/userConstants' ; 
import * as api from '../api/index.js' ; 
import { UPDATE_USER_COURSES_TAKEN } from '../constants/userConstants';

// Function that returns async funcction
export const signin = (formData, onClose, navigate, setErrorMessage)  =>  async (dispatch) => {
  try {
      // Log in the user
      const {data} = await api.signin(formData) ; 
      // Pass data to reducer
      dispatch({ type: AUTH, data})
      
      // Close the signup form
      onClose();
      navigate('/') ; 
  } catch(error)
  {
      setErrorMessage(error?.response?.data?.message); 
  }
};


// Function that returns async funcction
export const signup= (formData, onClose, navigate, setErrorMessage)  =>  async (dispatch) => {
  try {
      // Sign up the user
      const {data} = await api.signup(formData) ;
      // Pass data to reducer
      dispatch({ type: AUTH, data})

      // Close the signup form
      onClose();
      navigate('/');

  } catch(error)
  {
    console.log("Error",error)
    setErrorMessage(error?.response?.data?.message); 
  }
};

// Function that returns async funcction
export const signuporingoogle= (googleToken, onClose, navigate, setErrorMessage)  =>  async (dispatch) => {
  try {
      const response = await api.signuporingoogle({googleToken:googleToken}) ; 
      if (response.status===200) {
        const data = response.data
        // Store  app's JWT token
        dispatch({ type: AUTH, data})
        // Close the signup form
        onClose();
        navigate('/');


        // Redirect or update UI
      } else {
        setErrorMessage('Authentication failed:', response.message);
      }
    } catch (error) {
      setErrorMessage('Network error');
    }
};


export const updateUserCoursesTaken=(id, course_taken) => async (dispatch) =>{
  try{
      const result = await api.updateUserCourseTaken(id, course_taken) ; 
      const coursesTaken = result.data
      dispatch( {type: UPDATE_USER_COURSES_TAKEN, payload: coursesTaken})
  } catch (error) {
      console.log(error) ; 
  }
}


// Function that returns async funcction
export const forgotPassword = (email, setErrorMessage)  =>  async (dispatch) => {

    try {
      const response = await api.forgotpassword({ email });
      console.log(response)
      setErrorMessage(response.data.message);
    } catch (error) {
      console.log(error)
      setErrorMessage('An error occurred. Please try again.');
    }
}


// Function that returns async funcction
export const resetPassword = (password, confirmPassword, token, navigate, setErrorMessage)  =>  async (dispatch) => {
    const formData = {password, confirmPassword}
    console.log(formData)
    try {
      const response = await api.resetpassword(token, formData);
      console.log("Responded")
      console.log(response)
      setErrorMessage(response.data.message);
    } catch (error) {
      // Network error or server returned error status (4xx, 5xx)
      if (error.response) {
        // Server responded with error status
        setErrorMessage(error.response.data.message || 'Error resetting password');
      }  else {
        // Network error
        console.log('Network error');
      }
      // setErrorMessage('An error occurred. Please try again.');
    }
}

 